import { Route, Routes } from "react-router-dom";
import { CommercialForm, Marcom } from "../../pages/Admin";
import Dashboard from "../../pages/Admin/Dashboard/Dashboard";
import AdminForgot from "../../pages/Admin/Login/AdminForgot";
import AdminLogin from "../../pages/Admin/Login/AdminLogin";
import NotificationConfig from "../../pages/Admin/Notifications/NotificationConfig";
import AdminLayout from "../../themes/AdminLayout/AdminLayout";
import PrivateRoute from "../PrivateRoute";
import AccountManagementRoute from "./AccountManagementRoute";
import AccountSettingsRoute from "./AccountSettingsRoute";
import DatabaseRoute from "./DatabaseRoute";
import OperationsRoute from "./OperationsRoute";
import NotificationView from "../../pages/Admin/UserNotification/NotificationView";
import SiteLog from "../../pages/Admin/SiteManager/SiteLog";

const AdminRoute = () => {
  const protected_routes = () => {
    return (
      <Routes>
        <Route
          path="/siteLog"
          element={
            <AdminLayout>
              <SiteLog />
            </AdminLayout>
          }
        />
        <Route
          path="/dashboard"
          element={
            <AdminLayout>
              <Dashboard />
            </AdminLayout>
          }
        />
        <Route
          path="/operations/*"
          element={
            <AdminLayout>
              <OperationsRoute />
            </AdminLayout>
          }
        />
        <Route
          path="/account-settings/*"
          element={
            <AdminLayout>
              <AccountSettingsRoute />
            </AdminLayout>
          }
        />
        <Route
          path="/account-management/*"
          element={
            <AdminLayout>
              <AccountManagementRoute />
            </AdminLayout>
          }
        />
        <Route
          path="/database/*"
          element={
            <AdminLayout>
              {" "}
              <DatabaseRoute />
            </AdminLayout>
          }
        />
        <Route
          path="/notification"
          element={
            <AdminLayout>
              <NotificationConfig />
            </AdminLayout>
          }
        />
        <Route
          path="/notification/:type"
          element={
            <AdminLayout>
              {" "}
              <NotificationView />{" "}
            </AdminLayout>
          }
        />
        <Route
          path="/marcom"
          element={
            <AdminLayout>
              <Marcom />
            </AdminLayout>
          }
        />
        <Route
          path="/commercial"
          element={
            <AdminLayout>
              {" "}
              <CommercialForm />
            </AdminLayout>
          }
        />
        <Route path="/forgot" element={<AdminForgot />} />
      </Routes>
    );
  };

  return (
    <Routes>
      <Route path="" element={<AdminLogin />} />
      <Route path="/forgot-password" element={<AdminForgot />} />
      <Route
        path="/*"
        element={<PrivateRoute>{protected_routes()}</PrivateRoute>}
      />
    </Routes>
  );
};

export default AdminRoute;
/*
<Route path="/dashboard" element={<AdminLayout><Dashboard /></AdminLayout>} />
*/
